<template>
  <router-view />
</template>

<script>

export default {
  name: 'AddressWrapper'
}
</script>
